import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_TASKS = `${API_URL}/tasks/getAllTasks`
const ADD_TASK_DETAILS = `${API_URL}/tasks`;
const UPDATE_TASKS_DETAILS = `${API_URL}/tasks/`;

export const getTasks = createAsyncThunk(
  "getTasks",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_TASKS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateTaskDetails = createAsyncThunk(
  "updateTaskDetails",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${UPDATE_TASKS_DETAILS}${values.id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getTasks({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addTaskDetails = createAsyncThunk(
  "addTaskDetails",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${ADD_TASK_DETAILS}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getTasks({ page: values.selectedPage || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);


export const deleteTask = createAsyncThunk(
  "deleteTask",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${UPDATE_TASKS_DETAILS}${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getTasks({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);
